import styled from '@emotion/styled'

export const IconButtonWithLabelWrapper = styled.div`
  display: flex;
  align-items: center;
  flex-direction: column;
`
